import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import api, {getQuery, query} from 'api';
import {MainTitleDark} from 'ui';
import ListItem from './listItem';
import ActionDetail from './ActionDetail';
import VisibilityProof from './VisibilityProof';
import {PageContainer, Grid, BackButton} from './styles';

const selectProfileState = state => getQuery(state, api.getProfile);

// Textes d'état du cartouche « Visibilité » de la page /recompense/.
const visibilityStatus = {
  pending: 'En attente de validation du commercial',
  granted: 'Points déjà attribués pour cette année.',
};

// Les cartes reprennent les actions du bloc « Comment obtenir plus de points ? » de la page
// /recompense/ : mêmes contenus, même ordre, même badge et même marche à suivre.
const MorePointsPage = ({data}) => {
  const dispatch = useDispatch();
  const visibility = useSelector(selectProfileState).data?.visibility;
  const [openedAction, setOpenedAction] = useState(null);
  const [proofAction, setProofAction] = useState(null);

  useEffect(() => {
    dispatch(api.getProfile());
  }, [dispatch]);

  const cardProps = item => {
    if (visibility && item.id === visibility.action_id) {
      if (visibilityStatus[visibility.state]) return {status: visibilityStatus[visibility.state]};
      return {openLabel: 'Envoyer ma preuve', onOpen: () => setProofAction(item)};
    }
    return {onOpen: item.acf.actions_modal_enabled ? () => setOpenedAction(item) : null};
  };

  return (
    <PageContainer>
      <BackButton to="/gifts" />
      <MainTitleDark style={{fontSize: 26, marginBottom: 24}}>
        Comment obtenir plus
        <br /> de points ?
      </MainTitleDark>

      <Grid>
        {data.map(item => (
          <ListItem
            key={item.id}
            points={item.acf.actions_points}
            image={item.acf.actions_image}
            title={item.title.rendered}
            isNew={!!item.acf.actions_new}
            {...cardProps(item)}
          />
        ))}
      </Grid>

      {openedAction && <ActionDetail action={openedAction} onClose={() => setOpenedAction(null)} />}
      {proofAction && (
        <VisibilityProof
          action={proofAction}
          visibility={visibility}
          onClose={() => setProofAction(null)}
          onSent={() => dispatch(api.getProfile())}
        />
      )}
    </PageContainer>
  );
};

MorePointsPage.propTypes = {
  data: PropTypes.array,
};

export default MorePointsPage |> query('getMorePoints', {loadingFullWidth: true});
